/* eslint-disable import/prefer-default-export */
export const GET_DEDICATED_CONNECTED_USERS_URL = `https://slot.tizeti.com/geniatechapi/index.php`;
